<template>

    <table class="table">
        <thead>
            <tr>
                <th v-for="column in tableDefs.columns" :key="column.key" :class="[{filtered : (column.activeFilter || column.activeSort)}]" :width="column.width" v-show="column.hide == null || column.hide == false">
                    <span v-html="column.label"></span>
                    <i v-if="column.sortable || column.filter" class="fa fa-cog" v-on:click="popupHandler(column)" ></i>
                    <TableFilterPopup v-if="column.sortable || column.filter" :columnData="column" v-on:sort="handleSort" v-on:filter="handleFilter"></TableFilterPopup>
                </th>
                <th v-if="tableDefs.rowActions.actions"></th>
            </tr>
        </thead>

            <tr v-for="item in tableDataObject">
                <td v-for="column in tableDefs.columns" :key="column.key" :class="[column.className,getSpRowClassname(item)]" :width="column.width" @click="onClickCell(column,item)"  v-show="column.hide == null || column.hide == false">
                    <component v-bind:is="column.renderer" :object="item" v-if="handleRendererComponent(column.renderer)" v-dynamic-events="knownEvents"></component>
                    <span v-if="handleRendererFunction(column.renderer)" v-html="column.renderer(item)"></span>
                    <router-link v-if="column.linkTo && !column.renderer" :to="parseLink(column.linkTo,item)">{{ accessValue(item,column.key) }}</router-link>
                    <span v-if="!column.renderer && !column.linkTo"><!--
                        -->{{ accessValue(item,column.key) }}<!--
                    --></span>
                </td>
                <td :width="tableDefs.rowActions.width" v-if="tableDefs.rowActions.actions" :class="getSpRowClassname(item)">
                    <span class="actions">
                        <router-link v-for="action in tableDefs.rowActions.actions" :key="action.label" tag="i" :to="parseLink(action.linkTo,item)" :class="action.class" :title="action.label" @click.native.prevent="onClickAction(action,item)"></router-link>
                    </span>
                </td>
            </tr>
        <tbody v-if="!tableDataObject ||  tableDataObject.length == 0">
            <tr class="no-content">
                <td v-if="tableDefs.global && tableDefs.global.noItemsMsg" :colspan="nbColumns" v-html="tableDefs.global.noItemsMsg"></td>
            </tr>
        </tbody>
    </table>

</template>

<script>
    import TableFilterPopup from "./TableFilterPopup";

    export default {
        name: 'supertable',
        components: {
            TableFilterPopup
        },
        props: {
            tableColumns: {
                type: Object,
                required: true
            },
            tableData: {
                type: Array,
                required: true
            },
            options: {
                type: Object,
                default: function(){
                    return {
                        disabled: true
                    }
                }
            }
        },
        data: () => ({
            nbPages: 7,
            currentPage: 1,
            tableDefs: function(){
                return this.tableColumns;
            },
            knownEvents: [
                'expired',
                'qrcode',
                'cancel',
                'send',
                'sendfirsttime'
            ]

        }),
        directives: {
            DynamicEvents: {
                bind: function (el, binding, vnode) {
                    const allEvents = binding.value;
                    allEvents.forEach((event) => {
                        // register handler in the dynamic component
                        vnode.componentInstance.$on(event, (eventData) => {
                            // when the event is fired, the proxyEvent function is going to be called
                            vnode.context.proxyEvent(event, eventData);
                        });
                    });
                },
                unbind: function (el, binding, vnode) {
                    vnode.componentInstance.$off();
                },
            },
        },
        computed: {
            nbColumns: function(){
                var nbColumns = 0;
                if(this.tableDefs.rowActions != null && this.tableDefs.rowActions.actions != null && this.tableDefs.rowActions.actions.length > 0)
                    nbColumns++;

                nbColumns += this.tableDefs.columns.length;

                return nbColumns;
            },
            tableDataObject: function(){
                return this.tableData;
            }
        },
        methods: {
            handleEnd: function (evt) {
                this.$emit('endDrag', evt);
            },
            getSpRowClassname: function(item){
                if(item.spRowClassname != null){
                    var className = item.spRowClassname;
                    var result = item.spRowClassname.match(/{\s*[\w\.]+\s*}/g);
                    if(item.spRowClassname.match(/{\s*[\w\.]+\s*}/g)){
                        for(var i = 0; i<result.length; i++){
                            var key = result[i].replace('{','').replace('}','')
                            className = className.replace(result[i],item[key]);
                        }
                        return className;
                    }
                    else{
                        return item.spRowClassname;
                    }

                }
                return '';
            },
            handleRendererComponent:function(renderer){
                if(typeof renderer === 'object'){
                    return true;
                }
                return false
            },
            handleRendererFunction:function(renderer){
                if(typeof renderer === 'function'){
                    return true;
                }
                return false
            },
            popupHandler: function(column){
                column.showPopup = true;
            },
            handleSort: function(column,sort){
                //this.unactivateSortAndFilter();
                column.activeSort = sort;
                this.$emit('sort');
            },
            handleFilter: function(column,filter){
                //this.unactivateSortAndFilter();
                column.activeFilter = filter;
                this.$emit('filter');
            },
            unactivateSortAndFilter: function(){

                for(var cKey in this.tableColumns.columns){
                    var col = this.tableColumns.columns[cKey];
                    col.activeSort = false;
                    col.activeFilter = false;
                }
            },
            parseLink: function(linkToParse, data){
                if(linkToParse == null)
                    return "";

                var link = linkToParse;

                for(var column in data){
                    link = link.replace(':'+column,data[column]);
                }

                return link;
            },
            onClickCell(column,item){
                if(column.event)
                {
                    this.$emit(column.event, item);
                }
            },
            onClickAction: function(action, item){
                if(action.event)
                {
                    this.$emit(action.event, item);
                }

            },
            accessValue: function(data,key){

                var _index = key.indexOf('.')
                if(_index > -1) {
                    return this.accessValue(data[key.substring(0, _index)], key.substr(_index + 1));
                }

                return data[key];
            },
            proxyEvent(eventName, eventData) {
                this.$emit(eventName,eventData);
            }
        },
        created: function(){
            this.tableDefs = this.tableColumns;
            this.tableDataObject = this.tableData;
            this.$nextTick(function(){
            })
        },
        mounted: function(){

            this.tableDefs = this.tableColumns;
            this.tableDataObject = this.tableData;
        },
        updated: function(){
            this.tableDefs = this.tableColumns;
            this.tableDataObject = this.tableData;
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/table/Table.vue